import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { ClientRoutingModule } from './client-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxMaskModule } from 'ngx-mask';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { TotemComponent } from './pages/totem/totem.component';
import { PinTotemComponent } from './pages/totem/pages/pin-totem/pin-totem.component';
import { TotemSuccessComponent } from './pages/totem/pages/totem-success/totem-success.component';
import { TotemOptionsComponent } from './pages/totem/pages/totem-options/totem-options.component';
import { TotemPriorityListComponent } from './pages/totem/pages/totem-options/totem-priority-list/totem-priority-list.component';
import { TotemCustomListComponent } from './pages/totem/pages/totem-options/totem-custom-list/totem-custom-list.component';
import { CpfTotemComponent } from './pages/totem/pages/totem-options/cpf-totem/cpf-totem.component';
import { PatientNotFoundComponent } from './pages/totem/pages/totem-options/cpf-totem/patient-not-found/patient-not-found.component';
import { PatientFoundComponent } from './pages/totem/pages/totem-options/cpf-totem/patient-found/patient-found.component';
import { PatientArrivedEarlyLateModalComponent } from './pages/totem/pages/totem-options/cpf-totem/patient-arrived-early-late-modal/patient-arrived-early-late-modal.component';
import { PatientWithoutSchedulingModalComponent } from './pages/totem/pages/totem-options/cpf-totem/patient-without-scheduling-modal/patient-without-scheduling-modal.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DisplayComponent } from './pages/display/display.component';
import { DisplayOptionsComponent } from './pages/display/display-options/display-options.component';
import { DisplayStandartTemplateComponentV2 } from './pages/display/display-options/display-standart-template-v2/display-standart-template-v2.component';
import { DisplayStandartTemplateComponent } from './pages/display/display-options/display-standart-template/display-standart-template.component';
import { DisplayLayoutRightTemplateComponent } from './pages/display/display-options/display-layout-right-template/display-layout-right-template.component';
import { DisplayLayoutLeftTemplateComponent } from './pages/display/display-options/display-layout-left-template/display-layout-left-template.component';
import { PhotoModalComponent } from './pages/totem/pages/totem-options/cpf-totem/photo-modal/photo-modal.component';
import { TutorialPhotoModalComponent } from './pages/totem/pages/totem-options/cpf-totem/tutorial-photo-modal/tutorial-photo-modal.component';
import { OutdatedAddressModalComponent } from './pages/totem/pages/totem-options/cpf-totem/outdated-address-modal/outdated-address-modal.component';

@NgModule({
  declarations: [
    TotemComponent,
    PinTotemComponent,
    TotemSuccessComponent,
    TotemOptionsComponent,
    TotemPriorityListComponent,
    TotemCustomListComponent,
    CpfTotemComponent,
    PatientNotFoundComponent,
    PatientFoundComponent,
    PatientArrivedEarlyLateModalComponent,
    PatientWithoutSchedulingModalComponent,
    DisplayComponent,
    DisplayOptionsComponent,
    DisplayStandartTemplateComponentV2,
    DisplayStandartTemplateComponent,
    DisplayLayoutRightTemplateComponent,
    DisplayLayoutLeftTemplateComponent,
    PhotoModalComponent,
    TutorialPhotoModalComponent,
    OutdatedAddressModalComponent
  ],
  imports: [
    CommonModule,
    ClientRoutingModule,
    NgxMaskModule.forRoot(),
    MatProgressSpinnerModule,
    MatInputModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatCheckboxModule,
    MatDialogModule,
    MatNativeDateModule,
    SharedModule,
    MatFormFieldModule,
  ]
})
export class ClientModule { }
